export default __webpack_public_path__ + "static/media/4.d32a0b79.jpg";